import React from 'react'
import StatusChange from './StatusChange'

const TenantStatusChange = () => {
    return (
        <StatusChange />
    )
}

export default TenantStatusChange